/// \file fleetRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Route } from "react-router-dom";
import assetManagementRoutes from './assetManagementRoutes';
import fleetAsset from './fleetAsset';
import fleetDashboard from './fleetDashboard';
import fleetFaults from './fleetFaults';
import fleetFaultsAnalytics from './fleetFaultsAnalytics';
import fleetActivity from './fleetActivity';
const routes = (
  <Route
    path="fleet"
    handle={{
      text: 'Fleet'
    }}
    >
    {assetManagementRoutes}
    {fleetAsset}
    {fleetDashboard}
    {fleetFaults}
    {fleetFaultsAnalytics}
    {fleetActivity}
  </Route>
);

export default routes;